/** @format */

import { useContext } from 'react';
import { MorabishoooContext } from '../../Contexts/MorabishoooContext';

export const useRole = () => {
	const morabishoooContext = useContext(MorabishoooContext);
	let roles = morabishoooContext.authRoles.map((r) => r.name);
	const can = (role) => {
		return roles.includes(role);
	};

	const canBoard = () => {
		return roles?.find((u) => u?.startsWith('Board')) !== undefined;
	};

	return {
		can: (role) => can(role),
		canBoard: () => canBoard(),
	};
};
